import React from "react";
import { Route, Switch } from "react-router-dom";
import { default as ProfileIndex } from "../../../pages/expert/show";

export const ExpertShowRoutes = <Switch>
  <Route
    path="/v2/expert/:expertId/profile"
    component={ProfileIndex} />
</Switch>;
